<template>
<div>
    <a href='#' @click="goTo({path: '/mf/minhas-doacoes', event: 'listDonations' })" class='back-button'> <font-awesome-icon title='Voltar' icon="fa-arrow-left" /> </a>
    <table class='recepts-table'>
    <thead>
      <tr> <th colspan='4'> Recibos </th></tr>
      <tr>
        <th> Valor </th>
        <th> Situação </th>
        <th> Mês </th>
        <th> Ações </th>
      </tr>
    </thead>
      <tr v-for="(receipt) in receipts" :key="receipt.id">
        <td> {{receipt.amount}} </td>
        <td> {{receipt.state}} </td>
        <td> {{receipt.created_at}} </td>
        <td>
          <a href='#'  @click="printReceipt(receipt.id)" >
            <font-awesome-icon class='icon' title='Baixar recibo' icon="fa-print" />
          </a>
        </td>
      </tr>
    <tbody>
    </tbody>
    </table>
    <div id='print-content'>
      <p> </p>
    </div>
  </div>

</template>

<style type="text/css">
    @import url("https://donatorarea.s3.amazonaws.com/assets/bootstrap/css/bootstrap.min.css");
    @import url("https://donatorarea.s3.amazonaws.com/assets/css/font-awesome.min.css");
    .recepts-table{
        border: 2px solid #55006D;
        margin: auto;
        margin-top: 20px;
    }
    .recepts-table td, .recepts-table th{
      border: 2px solid #55006D;
      border-collapse: collapse;
      padding:8px 16px;
    }
    .recepts-table th{
      text-align: center;
      background: none;
    }
    .recepts-table a {
      color: inherit;
    }
    @media print {
      #print-content {
        display: block;
      }

      .recepts-table {
        display: none;
      }

      .back-button {
        display: none;
      }
    }
</style>

<script>
import { setupAxios } from '../../setupAxios';
import { getReceipts } from '../../apiClient';
import { printReceipt } from '../utils';

export default {
  name: 'ListReceipts',
  props: {
    admin: { type: Boolean, default: false },
    donationId: { type: Number }
  },
  data: () => ({
    receipts: []
  }),
  mounted: async function () {
    this.axios = setupAxios();
    await this.getReceipts();
  },
  methods: {
    async getReceipts () {
      let donationId = this.admin ? this.donationId : this.$route.params.id;
      const result = await getReceipts(this.axios, donationId);
      this.receipts = result.data;
    },
    printReceipt (receiptId) {
      const receipt = this.receipts.find(d => d.id === receiptId);
      printReceipt(receipt);
    },
    goTo (params) {
      if (this.admin) {
        this.$emit(params.event, { event: params.event });
      } else {
        this.$router.push({ path: params.path });
      }
    }
  }

};
</script>
